import $ from 'jquery'
import algoliasearch from 'algoliasearch/lite'
import instantsearch from 'instantsearch.js'
import {
  configure,
  refinementList,
  clearRefinements,
} from 'instantsearch.js/es/widgets'
import { connectSearchBox } from 'instantsearch.js/es/connectors'
import { connectInfiniteHits } from 'instantsearch.js/es/connectors'
import { history } from 'instantsearch.js/es/lib/routers'
import { recipeHit, recipeButtun } from '../components/recipeHit'
import searchBox from '../components/searchBox'
import showMoreText from '../components/showMoreText'
import { algoliaAppId, algoliaApiKey, recipeSearchIndex } from '../variables'
import { dynamicUriTemplate, extractParamsFromUri } from '../functions'
import infiniteHits from '../components/infiniteHits'

// eslint-disable-next-line no-undef
const { __ } = wp.i18n

// eslint-disable-next-line no-undef
const object = vnObject

const { mainSlug, query, restorationTypes, recipeTypes, recipeOtherFilters } =
  object.recipesQueryStrings

const slugs = {
  query,
  restorationTypes,
  recipeTypes,
  recipeOtherFilters,
}

let recipeSearch
const checkEl = document.querySelector('.pt-recipes__posts')
if (checkEl) {
  const searchClient = algoliasearch(algoliaAppId, algoliaApiKey)
  const customInfiniteHits = connectInfiniteHits(
    infiniteHits(recipeHit, recipeButtun)
  )

  recipeSearch = instantsearch({
    indexName: recipeSearchIndex,
    searchClient,
    insights: true,
    clickAnalytics: true,
    routing: {
      router: history({
        createURL({ routeState, location }) {
          const params = {
            restorationTypes: routeState.restorationTypes,
            recipeTypes: routeState.recipeTypes,
            recipeOtherFilters: routeState.recipeOtherFilters,
            query: routeState.query,
          }

          return dynamicUriTemplate(location.origin, params, mainSlug, slugs)
        },

        parseURL({ location }) {
          const params = extractParamsFromUri(location.href, slugs)

          return {
            query: params[slugs.query] && params[slugs.query][0],
            restorationTypes: params[slugs.restorationTypes],
            recipeTypes: params[slugs.recipeTypes],
            recipeOtherFilters: params[slugs.recipeOtherFilters],
          }
        },
      }),

      stateMapping: {
        stateToRoute(uiState) {
          const indexUiState = uiState[recipeSearchIndex] || {}

          const res = {
            query: indexUiState.query,
            restorationTypes:
              indexUiState.refinementList?.['restorationTypes.name'],
            recipeTypes: indexUiState.refinementList?.['recipeTypes.name'],
            recipeOtherFilters:
              indexUiState.refinementList?.['recipeOtherFilters.name'],
          }
          return res
        },

        routeToState(routeState) {
          return {
            [recipeSearchIndex]: {
              query: routeState.query,
              refinementList: {
                'restorationTypes.name': routeState.restorationTypes,
                'recipeTypes.name': routeState.recipeTypes,
                'recipeOtherFilters.name': routeState.recipeOtherFilters,
              },
            },
          }
        },
      },
    },
  })

  const customSearchBox = connectSearchBox(searchBox)

  recipeSearch.addWidgets([
    customSearchBox({
      container: document.querySelector('.product-search-handler'),
      placeholder: __('Search...', 'vn'),
    }),

    clearRefinements({
      container: '.product-active-filters-handler',
      templates: {
        resetLabel({ hasRefinements }, { html }) {
          return html`<span
            >${hasRefinements
              ? __('Remove filters', 'vn')
              : __('No filters', 'vn')}</span
          >`
        },
      },
    }),

    refinementList({
      container: '.restoration-types-handler',
      attribute: 'restorationTypes.name',
      sortBy: ['name'],
      showMore: true,
      templates: {
        showMoreText(data) {
          return showMoreText(data)
        },
      },
    }),

    refinementList({
      container: '.recipe-types-handler',
      attribute: 'recipeTypes.name',
      sortBy: ['name'],
      showMore: true,
      templates: {
        showMoreText(data) {
          return showMoreText(data)
        },
      },
    }),

    refinementList({
      container: '.specialties-handler',
      attribute: 'specialties.name',
      sortBy: ['name'],
      showMore: true,
      templates: {
        showMoreText(data) {
          return showMoreText(data)
        },
      },
    }),

    refinementList({
      container: '.recipe-other-filters-handler',
      attribute: 'recipeOtherFilters.name',
      sortBy: ['name'],
      showMore: true,
      templates: {
        showMoreText(data) {
          return showMoreText(data)
        },
      },
    }),

    customInfiniteHits({
      container: document.querySelector('.recipe-hits-handler'),
    }),

    configure({
      hitsPerPage: 8,
    }),
  ])

  recipeSearch.start()
}

$(document).on(
  'click',
  '.pt-recipes .filter-sidebar__widget label',
  function () {
    document
      .querySelector('.pt-recipes__posts')
      .scrollIntoView({ behavior: 'smooth' })
  }
)
